import styled from '@emotion/styled';
import React, { useMemo } from 'react';
import { BestType } from '@diritto/common/best/constants';
import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { accurateItems, flatItems } from '@diritto/common/utils/array';
import { useAuthState } from 'contexts/AuthProvider';
import { RankingContentList } from 'app-components/ranking/RankingContentList';
import { InfiniteScrollWrapper } from 'ui-components/common/InfiniteScrollWrapper';
import { EmptyList } from 'ui-components/common/EmptyList';
import { useGetRelayRankingContentsInfiniteQuery } from 'queries/relay/useGetRelayRankingContentsInfiniteQuery';
import { useHomeSettingState } from 'contexts/HomeSettingProvider';

export const RankingContentListView = ({ categoryId, bestType }: { categoryId?: number; bestType: BestType }) => {
  const { includeAdult } = useAuthState();
  const { categoryIds: favoriteCategoryIds } = useHomeSettingState();

  const { data, hasNextPage, fetchNextPage, isFetched } = useGetRelayRankingContentsInfiniteQuery(
    { categoryId, includeAdult, categoryIds: favoriteCategoryIds.join(',') },
    bestType,
  );

  const aggregatedAt = useMemo(() => data?.pages?.[0]?.aggregatedAt, [data?.pages]);

  const { contentIds, contents, profiles } = useMemo(
    () => ({
      contentIds: flatItems<number>('contentIds', data?.pages) ?? [],
      contents: accurateItems<ContentRelayDto>('contents', data?.pages),
      profiles: accurateItems<ProfileLiteRelayDto>('profileLites', data?.pages),
    }),
    [data],
  );

  if (isFetched && contentIds.length === 0) {
    return <EmptyList description="아직 베스트 작품이 없어요." />;
  }

  return (
    <StyledContentList>
      {contentIds && contents && profiles && (
        <InfiniteScrollWrapper hasNext={hasNextPage} loadMore={fetchNextPage}>
          <RankingContentList
            contentIds={contentIds}
            contents={contents}
            profiles={profiles}
            aggregatedAt={aggregatedAt}
            bestType={bestType}
            categoryId={categoryId}
          />
        </InfiniteScrollWrapper>
      )}
    </StyledContentList>
  );
};

const StyledContentList = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 50vh;
`;
